<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Price List was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Price List - {{ this.priceList.name }}</h1>
    <app-audit-line [data]='this.priceList'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-price-list-form [otherItems]='this.otherItems' [account]='this.account' [priceList]='this.priceList' [priceListItems]='this.items' [editMode]='true'></app-price-list-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/price-list'>Cancel</button>
    </form>
  </div>
</div>
